// Edit Time duration rules (QA batch 12, 2026-10-21): hours and minutes are
// whole numbers, minutes 0-59, the entry is at least 1 minute and at most 24
// hours. Before, letters / 999 hours were saved (as 00h 00m or 999 h) and
// minutes over 59 were cut without a word. The server checks the same
// (`Services/TimeEntryRules.cs`).

export const TIME_NUMBERS_ONLY = "Hours and minutes must be whole numbers.";
export const TIME_MINUTES_RANGE = "Minutes must be between 0 and 59.";
export const TIME_TOO_SHORT = "Enter a duration of at least 1 minute.";
export const TIME_TOO_LONG = "A time entry can't be longer than 24 hours.";

export const MAX_ENTRY_SECONDS = 24 * 60 * 60;

/** The problem with a typed duration, or "" when fine. */
export const durationProblem = (value: { h: string; m: string }): string => {
  const h = (value.h ?? "").trim();
  const m = (value.m ?? "").trim();
  if ((h && !/^\d+$/.test(h)) || (m && !/^\d+$/.test(m))) {
    return TIME_NUMBERS_ONLY;
  }
  const hours = h ? parseInt(h, 10) : 0;
  const minutes = m ? parseInt(m, 10) : 0;
  if (minutes > 59) return TIME_MINUTES_RANGE;
  const seconds = hours * 3600 + minutes * 60;
  if (seconds <= 0) return TIME_TOO_SHORT;
  if (seconds > MAX_ENTRY_SECONDS) return TIME_TOO_LONG;
  return "";
};

/** What a typed hour/minute box would reject (shown instead of ignoring the key). */
export const typedTimeProblem = (part: "h" | "m", typed: string): string => {
  if (!/^\d*$/.test(typed)) return TIME_NUMBERS_ONLY;
  if (part === "m" && typed !== "" && parseInt(typed, 10) > 59) {
    return TIME_MINUTES_RANGE;
  }
  return "";
};

/** Edit Time / Add time: an emptied or unreadable date (QA batch 15). */
export const EDIT_TIME_DATE_PROBLEM =
  "Enter a date like Oct 21, 2026 (or pick one in the calendar).";
